import { render } from "./MemoryComponent.vue?vue&type=template&id=34e3b980&scoped=true&ts=true"
import script from "./MemoryComponent.vue?vue&type=script&lang=ts"
export * from "./MemoryComponent.vue?vue&type=script&lang=ts"

import "./MemoryComponent.vue?vue&type=style&index=0&id=34e3b980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e3b980"]])

export default __exports__